$(document).ready(function () {
  $(document).on("click", ".geo-modal .close-modal", function (event) {
    event.preventDefault();
    var modal = $(this).closest(".geo-modal").fadeOut(200);
    if (modal.attr("id") === "confirm-locale-modal") {
      $(this).hasClass("dont-ask-again")
        ? (window.localStorage.geo_dont_ask = !0)
        : (window.sessionStorage.geo_redirect_dismissed = !0);
      var store = stores[window.localStorage.country];
      // console.log('store: ', store);
      (store || (store = INT),
        currentStore != store &&
          setTimeout(function () {
            showGeoNotification(store);
          }, 2e3));
    }
    return !1;
  });
});

var currentStore = null,
  EU = {
    hosts: ["cycliq.com"],
    protocol: "https:",
    ownership: "Europe",
    multiOwnership: "Europe",
    multiPlural: "Europe",
    plural: "International",
    storeCode: "EU",
  },
  UK = {
    hosts: ["cycliq.co.uk"],
    protocol: "https:",
    ownership: "UK",
    multiOwnership: "UK",
    multiPlural: "UK",
    plural: "the UK",
    storeCode: "UK",
  },
  INT = {
    hosts: ["cycliq.com"],
    protocol: "https:",
    ownership: "International",
    multiOwnership: "International",
    multiPlural: "International",
    plural: "ROW",
    storeCode: "INT",
  },
  AU = {
    hosts: ["cycliq.com.au"],
    protocol: "https:",
    ownership: "Australia",
    multiOwnership: "Australia",
    multiPlural: "Australia",
    plural: "Australia",
    storeCode: "AU",
  },
  stores = {
    AN: INT,
    AT: INT,
    AU,
    BE: INT,
    BG: INT,
    CA: INT,
    CH: INT,
    CY: INT,
    CZ: INT,
    DE: INT,
    DK: EU,
    EE: INT,
    ES: INT,
    EU,
    FI: INT,
    FR: INT,
    GB: UK,
    GR: INT,
    HR: INT,
    HU: INT,
    IE: INT,
    IL: INT,
    INT,
    IT: INT,
    JP: INT,
    KR: INT,
    LT: INT,
    LU: INT,
    LV: INT,
    MT: INT,
    NL: INT,
    NZ: INT,
    PL: INT,
    PT: INT,
    RO: INT,
    RU: INT,
    SE: INT,
    SI: INT,
    SK: INT,
    SG: INT,
    HK: INT,
    US: {
      hosts: ["cycliq.com"],
      protocol: "https:",
      ownership: "USA",
      multiOwnership: "the USA",
      multiPlural: "USA",
      plural: "the USA",
      prefix: "the ",
      storeCode: "US",
    },
    UK,
  };

$(function () {
  // Check for Shopify Admin's
  // console.log('window.Shopify.designMode: ', window.Shopify.designMode);
  if (window.Shopify.designMode) {
    console.log("Skipping Shopify Admin view");
    return;
  }

  // Check for country attribute override
  if (window.location.href.indexOf("country=") > -1) {
    console.log("Country override detected");

    window.localStorage.geo_dont_ask = 1;
    console.log("Skipping auto-redirect");
    return;
  }

  var currency = window.Shopify.currency.active;
  console.log("currency: ", currency);

  // Check for geo_dont_ask
  console.log(
    "window.localStorage.geo_dont_ask: ",
    window.localStorage.geo_dont_ask,
  );
  if (window.localStorage.geo_dont_ask) {
    console.log("Skipping auto-redirect");
    return;
  }

  /*
	// Check for BF signup
	var currentURL = window.location.href;
	if(currentURL) {
		if( currentURL.includes("black-friday-signup") ) {
			console.log('Skipping geoModal');
			return;
		}
	}
*/

  if (
    (function () {
      // Check for crawlers, and Shopify Admin's
      const robotList =
          "(360spider|a6-indexer|aboundex|acoonbot|addthis|adidxbot|admantx|adsbot-google|adsbot-google-mobile|advbot|ahrefsbot|aihitbot|aisearchbot|antibot|apis-google|applebot|arabot|archive.org_bot|backlinkcrawler|baiduspider|bibnum.bnf|biglotron|bingbot|binlar|blekkobot|blexbot|bnf.fr_bot|brainobot|bubing|buzzbot|careerbot|cc metadata scaper|ccbot|changedetection|chrome-lighthouse|citeseerxbot|coccoc|commons-httpclient|content crawler spider|convera|crawler4j|crystalsemanticsbot|curl|cxensebot|cyberpatrol|discobot|domain re-animator bot|domaincrawler|dotbot|drupact|duckduckbot|duplexweb-google|ec2linkfinder|edisterbot|elisabot|europarchive.org|exabot|ezooms|facebookexternalhit|facebot|fast enterprise crawler|fast-webcrawler|feedfetcher-google|findlink|findthatfile|findxbot|fluffy|fr-crawler|g00g1e.net|gigablast|gingercrawler|gnam gnam spider|google favicon|google-read-aloud|googlebot|googlebot-image|googlebot-mobile|googlebot-news|googlebot-video|googleweblight|grapeshotcrawler|grub.org|gslfbot|heritrix|httpunit|httrack|ia_archiver|ichiro|integromedb|intelium_bot|interfaxscanbot|ioi|ip-web-crawler.com|ips-agent|it2media-domain-crawler|java|jyxobot|lb-spider|libwww|linguee bot|linkdex|lipperhey|lipperhey seo service|livelapbot|lssbot|lssrocketcrawler|ltx71|mail.ru_bot|mediapartners-google|megaindex|memorybot|mj12bot|mlbot|msnbot|msrbot|nerdbynature.bot|nerdybot|netresearchserver|ngbot|niki-bot|nutch|openindexspider|orangebot|page2rss|panscient|phpcrawl|postrank|proximic|psbot|purebot|python-urllib|qwantify|retrevopageanalyzer|rogerbot|scribdbot|seekbot|semanticscholarbot|semrushbot|seokicks-robot|seznambot|simplecrawler|sistrix crawler|sitebot|siteexplorer.info|slurp|smtbot|sogou|spbot|speedy|summify|tagoobot|teoma|toplistbot|turnitinbot|tweetmemebot|twengabot|twitterbot|urlappendbot|usinenouvellecrawler|voilabot|voyager|wbsearchbot|web-archive-net.com.bot|webcompanycrawler|webcrawler|webmon|wesee:search|wget|wocbot|woriobot|wotbox|xovibot|y!j-asr|yacybot|yandexbot|yanga|yeti|yoozbot)",
        regex = new RegExp(robotList, "i"),
        userAgent = navigator.userAgent;
      // console.log('userAgent: ', userAgent);
      return !!regex.test(userAgent);
    })() ||
    window.Shopify.designMode
  )
    return;

  var $confirmModal = $("#confirm-locale-modal"),
    $selectModal = $("#select-locale-modal"),
    $dynamic = $confirmModal.find(".dynamic"),
    source = $dynamic.html(),
    $notification = $(".geo-notification"),
    $notificationText = $notification.find(".dynamic"),
    $notificationTextSource = $notificationText.html();
  // console.log('source: ', source);
  for (var key in stores) {
    if (
      stores.hasOwnProperty(key) &&
      ~stores[key].hosts.indexOf(window.location.host)
    ) {
      currentStore = stores[key];
      break;
    }
  }
  // console.log('currentStore: ', currentStore);
  /*
  window.sessionStorage.geo_redirect_dismissed || window.localStorage.geo_dont_ask || geoip2.country(function(response) {
    console.log(response);
    var store = stores[response.country.iso_code];
    store || (response.continent.code === "EU" ? store = EU : store = INT), window.localStorage.country = response.country.iso_code, ~store.hosts.indexOf(window.location.host) || (showGEOModal(store, response), document.querySelector("#modalTriggeredManually").style.display = "none", document.querySelector("#modalTriggeredAuto").style.display = "block")
  }, $.noop);
*/
  // console.log('window.sessionStorage.geo_redirect_dismissed: ', window.sessionStorage.geo_redirect_dismissed);
  // console.log('window.sessionStorage.geo_dont_ask: ', window.sessionStorage.geo_dont_ask);
  /*
	if (window.sessionStorage.geo_redirect_dismissed || window.localStorage.geo_dont_ask) {
		console.log('Skipping showGEOModal');
		return;
	}
*/

  /*
	// Have we run this before? Check if this is a non-AU/UK site visitor
	console.log('window.localStorage.geo_dont_ask: ', window.localStorage.geo_dont_ask);
	if (window.localStorage.geo_dont_ask) {
		console.log('Skip geoModal');
		return;
	}
*/

  var data = false;

  // Orbe? Are you out there...
  console.log("orbeSession: ", window.sessionStorage.orbeSession);
  if (window.sessionStorage.orbeSession) {
    let orbeSession = JSON.parse(window.sessionStorage.orbeSession);
    console.log("orbeSession: ", orbeSession);
    data = {
      country_code: orbeSession.geolocation.countryCode,
      continent_code: false,
    };
    console.log("data: ", data);
    window.localStorage.country = data.country_code;
    // Has continent already been set?
    if (!window.localStorage.continent) {
      window.localStorage.continent = false;
    }
  }

  // Have we run this before? Skip the geoip check
  console.log("window.localStorage.country: ", window.localStorage.country);
  console.log("window.localStorage.continent: ", window.localStorage.continent);
  if (window.localStorage.country) {
    if (
      ["CA", "JP", "AU", "GB", "KR", "NZ", "SG", "HK"].indexOf(
        window.localStorage.country,
      ) > -1 ||
      window.localStorage.continent == "EU"
    ) {
      var store = stores[window.localStorage.country];
      console.log("store: ", store);
      // debugger;

      if (!store) {
        console.log("Skipping auto-redirect");
        return;
      }

      var redirectURL = window.location.href;
      var link_domain = store.protocol + "//" + store.hosts[0];
      redirectURL = redirectURL.replaceAll(window.location.origin, link_domain);
      // console.log('redirectURL: ', redirectURL);

      console.log("Prepare to auto-redirect");

      console.log("Disable Orbe");
      $("#md-app-embed__modal").attr("style", "display: none !important");

      var appendedURL = new URL(redirectURL);
      if (
        (window.localStorage.continent == "EU" &&
          window.localStorage.country !== "GB") ||
        ["CA", "JP", "AU", "KR", "NZ", "SG", "HK"].indexOf(
          window.localStorage.country,
        ) > -1
      ) {
        appendedURL.searchParams.set("country", window.localStorage.country);
      }
      appendedURL.searchParams.set("redirected", 1);
      // console.log('appendedURL: ', appendedURL.href);

      console.log("Auto-redirecting...");
      // debugger;
      window.location.assign(appendedURL.href);
      return;
    } else {
      var store = stores[window.localStorage.country];
      console.log("store: ", store);

      if (!data) {
        data = {
          country_code: window.localStorage.country,
          continent_code: window.localStorage.continent,
        };
        console.log("data: ", data);
      }
      (store ||
        (window.localStorage.continent === "EU" &&
        window.localStorage.country !== "GB"
          ? (store = EU)
          : (store = INT)),
        ~store.hosts.indexOf(window.location.host) ||
          (showGEOModal(store, data),
          (document.querySelector("#modalTriggeredManually").style.display =
            "none"),
          (document.querySelector("#modalTriggeredAuto").style.display =
            "block")));
    }
  }

  // Here we go for the first time...
  $.get("https://api.ipinfo.io/lite/me?token=32522325d9002d", function (data) {
    // console.log('data: ', data);
    // Extra check for ipinfo.io false detection affecting NZ
    if (data.country_code == "AU" && currency === "USD") {
      var userLanguage =
        window.navigator.language || window.navigator.userLanguage;
      console.log("userLanguage: ", userLanguage); // Output: 'en-US', 'fr-FR', etc.
      if (userLanguage == "en-NZ") {
        data.country_code = "NZ";
      }
    }
    var store = stores[data.country_code];
    console.log("store: ", store);

    // debugger;
    console.log("data.country_code: ", data.country_code);
    console.log("data.continent_code: ", data.continent_code);
    // console.log('window.location.host:', window.location.host);
    window.localStorage.country = data.country_code;
    window.localStorage.continent = data.continent_code;
    if (
      store &&
      currency === "USD" &&
      ["CA", "JP", "KR", "NZ", "SG", "HK"].indexOf(data.country_code) > -1
    ) {
      console.log("Localised pricing");
      store = INT;
      data.localised = true;
      showGEOModal(store, data);
    } else if (
      store &&
      data.continent_code === "EU" &&
      data.country_code !== "GB" &&
      currency === "USD"
    ) {
      console.log("Bonjour! Guten Tag!");
      data.localised = true;
      store = EU;
      showGEOModal(store, data);
    } else {
      (store ||
        (data.continent_code === "EU" &&
        (data.country_code !== "GB" || currency === "USD")
          ? (store = EU)
          : (store = INT)),
        ~store.hosts.indexOf(window.location.host) ||
          (showGEOModal(store, data),
          (document.querySelector("#modalTriggeredManually").style.display =
            "none"),
          (document.querySelector("#modalTriggeredAuto").style.display =
            "block")));
    }
  });

  function showGEOModal(store, data) {
    console.log("Running showGEOModal");
    let current = null;
    for (var key2 in stores)
      if (
        stores.hasOwnProperty(key2) &&
        ~stores[key2].hosts.indexOf(window.location.host)
      ) {
        current = stores[key2];
        break;
      }
    let templateDataStructure = {
      current,
      ownership: store.ownership || "",
      prefix: store.prefix || "",
      multiPlural: store.multiPlural || "",
      plural: store.plural || "",
      domain: store.hosts[0],
      link_domain: store.protocol + "//" + store.hosts[0],
    };
    // console.log('current: ', current);
    // console.log('templateDataStructure: ', templateDataStructure);
    if (!templateDataStructure) {
      console.log("Skipping dynamicHTML");
      return;
    }
    // console.log('window.location.href:', window.location.href);
    // console.log('window.location.origin:', window.location.origin);
    // console.log('window.location:', window.location);
    var redirectURL = window.location.href;
    // console.log('redirectURL (original): ', redirectURL);
    redirectURL = redirectURL.replaceAll(
      window.location.origin,
      templateDataStructure.link_domain,
    );
    console.log("redirectURL (modified): ", redirectURL);
    // console.log('data.country_code: ', data.country_code);
    if (
      data.country_code == "AU" ||
      data.country_code == "GB" ||
      data.localised
    ) {
      console.log("Prepare to auto-redirect");

      console.log("Disable Orbe");
      $("#md-app-embed__modal").attr("style", "display: none !important");

      var appendedURL = new URL(redirectURL);
      console.log("data.localised: ", data.localised);
      if (data.localised) {
        appendedURL.searchParams.set("country", data.country_code);
      }
      appendedURL.searchParams.set("redirected", 1);
      console.log("appendedURL: ", appendedURL.href);

      console.log("Auto-redirecting...");
      // debugger;
      window.location.assign(appendedURL.href);
      return;
    } else {
      window.localStorage.geo_dont_ask = 1;
      console.log("Skipping auto-redirect");
      return;
    }
    var dynamicHTML = source;
    ((dynamicHTML = dynamicHTML.replaceAll(
      "{{multiPlural}}",
      templateDataStructure.multiPlural,
    )),
      (dynamicHTML = dynamicHTML.replaceAll("{{link_domain}}", redirectURL)),
      (dynamicHTML = dynamicHTML.replaceAll(
        "{{prefix}}",
        templateDataStructure.prefix,
      )),
      (dynamicHTML = dynamicHTML.replaceAll(
        "{{current.plural}}",
        templateDataStructure.current.plural,
      )),
      (dynamicHTML = dynamicHTML.replaceAll(
        "{{current.prefix}}",
        templateDataStructure.prefix,
      )),
      (dynamicHTML = dynamicHTML.replaceAll(
        "{{current.multiPlural}}",
        templateDataStructure.current.multiPlural,
      )),
      $dynamic.html(dynamicHTML),
      (document.querySelector("#modalTriggeredManually").style.display =
        "block"),
      (document.querySelector("#modalTriggeredAuto").style.display = "none"),
      $confirmModal.fadeIn(200));
  }

  function showGeoNotification2(store) {
    console.log("Skipping showGeoNotification2");
    return;

    // debugger;
    var notification_html = $notificationTextSource
      .replaceAll("{{multiPlural}}", store.multiPlural || "")
      .replaceAll(
        "{{link_domain}}",
        store.protocol + "//" + store.hosts[0] || 0,
      );
    ($notificationText.html(notification_html),
      $notification.addClass("active"));
  }

  ($('[href="#store-selector"]').on("click", function (event) {
    return (
      event.preventDefault(),
      $confirmModal.fadeOut(200),
      $selectModal.fadeIn(200),
      !1
    );
  }),
    $("[data-store-selector]").on("click", function (event) {
      (event.preventDefault(), $selectModal.fadeOut(200));
      let code = $(this).data("store-selector"),
        store = stores[code],
        data = false;
      return (store && showGEOModal(store, data), !1);
    }),
    $(document).on("click", ".geo-modal .close-modal", function (event) {
      event.preventDefault();
      var modal = $(this).closest(".geo-modal").fadeOut(200);
      if (modal.attr("id") === "confirm-locale-modal") {
        $(this).hasClass("dont-ask-again")
          ? (window.localStorage.geo_dont_ask = !0)
          : (window.sessionStorage.geo_redirect_dismissed = !0);
        var store = stores[window.localStorage.country];
        (store || (store = INT),
          currentStore != store &&
            setTimeout(function () {
              showGeoNotification2(store);
            }, 2e3));
      }
      return !1;
    }),
    $(".close-notification").on("click", function () {
      $notification.removeClass("active");
    }));
});
